import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class TwoFactorAuthConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getTwoFactorAuthEnabled(): boolean {
		return this.configService.get((x) => x.core.auth.twoFactorAuthentication?.isEnabled, false);
	}

	getCurrentCustomerSecurityOptionsEnabled(): boolean {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.currentCustomerSecurityOptionsEnabled,
			true
		);
	}

	getIsChangeMethodButtonEnabled(): boolean {
		return this.configService.get((x) => x.core.auth.twoFactorAuthentication?.isChangeMethodButtonEnabled, false);
	}

	getIsOtpTextAuthStateEnabled(): boolean {
		return this.configService.get((x) => x.core.auth.twoFactorAuthentication?.isOtpTextAuthStateEnabled, false);
	}

	getIsMethodSwitchingEnabled(): boolean {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.settings?.isMethodSwitchingEnabled,
			true
		);
	}

	getIs2FADisableEnabled(): boolean {
		return this.configService.get((x) => x.core.auth.twoFactorAuthentication?.settings?.is2FADisableEnabled, true);
	}

	getIsSecondarySectionEnabled(): boolean {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.settings?.isSecondarySectionEnabled,
			true
		);
	}

	getIsExtraProtectionSectionEnabled(): boolean {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.settings?.isExtraProtectionSectionEnabled,
			true
		);
	}

	getIsRememberDeviceEnabled(): boolean {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.settings?.isRememberDeviceEnabled,
			true
		);
	}

	getSuspiciousLoginEnabled(): boolean {
		return this.configService.get((x) => x.core.auth.twoFactorAuthentication?.suspiciousLoginEnabled, false);
	}

	getPostRegistrationOTPEnabled(): boolean {
		return this.configService.get((x) => x.core.auth.twoFactorAuthentication?.postRegistrationOTPEnabled, false);
	}

	getOneTimePasswordRequestEndpoint(): string {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.endpoints?.postOneTimePasswordRequest,
			"v1/authenticationchallenges"
		);
	}

	getSendOnetimePasswordEndpoint(): string {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.endpoints?.sendOnetimePassword,
			"v1/currentcustomer/current-customer-security-options"
		);
	}

	getVerifyUsersPasswordEndpoint(): string {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.endpoints?.verifyUsersPassword,
			"v1/credentials/up/verify"
		);
	}

	getOperateAuthMethodEndpoint(): string {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.endpoints?.operateAuthMethod,
			"v1/current-customer-security-options"
		);
	}

	getOperateAuthMethodAllEndpoint(): string {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.endpoints?.operateAuthMethodAll,
			"v1/current-customer-security-options/all"
		);
	}

	getDeviceEndpoint(): string {
		return this.configService.get(
			(x) => x.core.auth.twoFactorAuthentication?.endpoints?.customerDevice,
			"v1/current-customer-remembered-devices/"
		);
	}
}
